import { render } from "./EditKategoriProduk.vue?vue&type=template&id=f843722e"
import script from "./EditKategoriProduk.vue?vue&type=script&lang=js"
export * from "./EditKategoriProduk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__